import { rodTranslations } from '../locales/rods';
import { boatTranslations } from '../locales/boats';
import { baitTranslations } from '../locales/baits';
import { houseTranslations } from '../locales/houses';
import { premiumTranslations } from '../locales/premiumItems';

const allTranslations = {
  ...rodTranslations,
  ...boatTranslations,
  ...baitTranslations,
  ...houseTranslations,
  ...premiumTranslations
};

export function getTranslation(itemName, locale, field) {
  const item = allTranslations[itemName];
  if (!item) return itemName;
  return item[field]?.[locale] || itemName;
}
